import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HashRouter } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Button from '../ui/Button';

const { FiMenu, FiX } = FiIcons;

const NAV_LINKS = [
  { name: 'About Us', href: '#about' },
  { name: 'Services', href: '#services' },
  { name: 'Programs', href: '#programs' },
  { name: 'Journey', href: '#journey' },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HashRouter>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'
        }`}
      >
        <div className="container mx-auto px-6 max-w-7xl flex items-center justify-between">
          <a href="#" className="flex items-center gap-2">
            <img 
              src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782378834/Remove_Background_17322517_peesjl.png" 
              alt="Alpha Training Consultancy Logo" 
              className={`transition-all duration-300 ${
                isScrolled ? 'h-12' : 'h-16 brightness-0 invert'
              }`}
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <a 
                key={link.name} 
                href={link.href}
                className={`font-medium transition-colors hover:text-alpha-green ${
                  isScrolled ? 'text-alpha-navy' : 'text-white drop-shadow-md'
                }`}
              >
                {link.name}
              </a>
            ))}
            <Button variant="primary" className="ml-4">
              Contact Us
            </Button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button 
            className="md:hidden text-2xl"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <SafeIcon 
              icon={isMobileMenuOpen ? FiX : FiMenu} 
              className={isScrolled || isMobileMenuOpen ? 'text-alpha-navy' : 'text-white'} 
            />
          </button>
        </div>

        {/* Mobile Nav */}
        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="absolute top-full left-0 right-0 bg-white shadow-xl py-6 px-6 flex flex-col gap-4 md:hidden"
            >
              {NAV_LINKS.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="font-medium text-alpha-navy text-lg py-2 border-b border-gray-100"
                >
                  {link.name}
                </a>
              ))}
              <Button variant="primary" className="mt-4 w-full">
                Contact Us
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
    </HashRouter>
  );
};

export default Navbar;